module.exports = __webpack_public_path__ + "static/media/stofferingen-57.8ba6176d.jpg";